import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ObstetricalSummary } from "@/Patient/Models/MedicalSummary/ObstetricalSummary";

interface IObstetricalSummaryComponentProps {
    obstetricalSummary?: ObstetricalSummary;
    onBannerClick?: () => void;
}

class ObstetricalSummaryComponent extends BaseReactComponent<IObstetricalSummaryComponentProps, null> {
    public render(): JSX.Element {
        if (!cacheStore.ClinicSettings.IsObstetricalFileEnabled)
            return null;

        const summary = this.props.obstetricalSummary;
        const hightlight: React.CSSProperties = summary?.IsPregnant ? { color: "#4d9933" } : {};

        return (
            <div key="obstetrical-summary-key" className="banner-summary" style={hightlight} onClick={() => this.props.onBannerClick?.()}>
                {this.renderCounter("GravidaCounterLabel", "GravidaLabel", summary?.Gravida, summary?.Gravida ?? 0)}
                {this.renderCounter("TermCounterLabel", "TermLabel", summary?.Term, summary?.Term ?? 0)}
                {this.renderCounter("PrematureCounterLabel", "PrematureLabel", summary?.Premature, summary?.Premature ?? 0)}
                {this.renderAbortionCounter()}
                {this.renderCounter("LiveCounterLabel", "LiveLabel", summary?.Live, summary?.Live ?? 0)}
                {this.renderCounter("StillbirthCounterLabel", "StillbirthLabel", summary?.Stillbirth, summary?.Stillbirth ?? 0)}
            </div>
        );
    }

    private renderAbortionCounter(): React.ReactNode {
        const summary = this.props.obstetricalSummary;

        if (sessionStore.getCurrentEmployee().isActiveSiteBC())
            return this.renderCounter(
                "AbortionCounterLabel",
                "AbortionLabel",
                [
                    this.renderCounter("AbortionInducedCounterLabel", "ObstetricalFile_InducedAbortionLabel", summary?.AbortionInduced, summary?.AbortionInduced ?? 0, false),
                    this.renderCounter("AbortionSpontaneousCounterLabel", "ObstetricalFile_SpontaneousAbortionLabel", summary?.AbortionSpontaneous, summary?.AbortionSpontaneous ?? 0, false, false)
                ]
            );

        return this.renderCounter("AbortionCounterLabel", "AbortionLabel", summary?.Abortion, summary?.Abortion ?? 0);
    }

    private renderCounter(label: string, title: string, value: React.ReactNode, tooltipNumber: number = null, isBold: boolean = true, includeRightMargin: boolean = true): JSX.Element {
        return (
            <span key={label} className={includeRightMargin ? "margin-sm-right" : ""} title={`${cacheStore.GetString(title)}: ${tooltipNumber ?? 0}`}>
                <span style={{ fontWeight: isBold ? "bold" : "normal" }}>{`${cacheStore.GetString(label)} `}</span>
                <span>
                    {!value
                        ? 0
                        : Array.isArray(value)
                            ? <span>({value})</span>
                            : value
                    }
                </span>
            </span>
        );
    }
}

export { ObstetricalSummaryComponent };
